import { toast, type ExternalToast } from 'sonner';

type ToastOptions = Omit<ExternalToast, 'style'>;

const errorStyle = {
  '--normal-bg':
    'color-mix(in oklab, var(--destructive) 10%, var(--background))',
  '--normal-text': 'var(--destructive)',
  '--normal-border': 'var(--destructive)',
} as React.CSSProperties;

const successStyle = {
  '--normal-bg':
    'color-mix(in oklab, light-dark(var(--color-green-600), var(--color-green-400)) 10%, var(--background))',
  '--normal-text': 'light-dark(var(--color-green-600), var(--color-green-400))',
  '--normal-border':
    'light-dark(var(--color-green-600), var(--color-green-400))',
} as React.CSSProperties;

export const toaster = {
  error: (message: string, options?: ToastOptions) => {
    return toast.error(message, {
      closeButton: true,
      duration: Infinity,
      ...options,
      style: errorStyle,
    });
  },
  success: (message: string, options?: ToastOptions) => {
    toast.dismiss();
    return toast.success(message, {
      ...options,
      style: successStyle,
    });
  },
};
